import './button';
import './cart-page';
import './checkout-page';
import './product-page';
import './shortcode';
import './translated-plugin-terms';
import './translations';
import './compatibility/peachpay-elementor';
import {type WCPHPData} from '../../@type/woocommerce/php-data';
import {initSentry} from '../../@shared/ts/sentry';
import {BRANCH, COMMITHASH, LASTCOMMITDATETIME, VERSION, PLUGIN_VERSION} from '../../git';

declare const peachpay_data: WCPHPData;
declare global {
	interface Window {
		peachpayTestMode?: () => void;
	}
}

initSentry(`peachpay-checkout@${PLUGIN_VERSION}`, 'https://39b5a2e17e264bb5a6ea5abe9bc6cf61@o470066.ingest.sentry.io/5660513');

window.peachpayTestMode = function () {
	console.log('Peachpay Version: ' + peachpay_data.version);
	console.log();
	console.log('Git Info:');
	console.log('\tVERSION: ' + VERSION);
	console.log('\tCOMMITHASH: ' + COMMITHASH);
	console.log('\tBRANCH: ' + BRANCH);
	console.log('\tLASTCOMMITDATETIME: ' + LASTCOMMITDATETIME);

	document.querySelector('#pp-button-container')?.classList.remove('hide');
	document.querySelector('#pp-button-container-mini')?.classList.remove('hide');
	document.querySelector('.checkout-container')?.classList.remove('hide');
};
